var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('el-image',{staticClass:"no-data-img",attrs:{"src":require('imgs/no-data.webp'),"alt":"no-data"}}),_c('p',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.msg || '暂无数据'))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }